var render = function render(){var _vm=this,_c=_vm._self._c;return _c('welcome-wrapper',[_c('div',{staticClass:"welcome"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"title heebo",attrs:{"dir":"rtl"}},[_vm._v(" הכניסה ל PlayList ")])]),_c('div',{staticClass:"footer"},[_c('router-link',{staticClass:"theme-button-primary",attrs:{"to":"/reg"}},[_vm._v(" התחל ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }